<template>
  <b-modal
    v-model="modalOpen"
    centered
    title="تفاصيل التصنيف"
    footer-class="removed"
    class="edit-modal"
    id="classModal"
    no-close-on-backdrop
  >
    <b-card-text>
      <b-form @submit.prevent>
        <b-row>
          <b-col cols="12">
            <form-select
              push-tags
              label="عنوان التصنيف"
              v-model="form.ngo_classification_id"
              :getOptionLabel="(x) => x.name_ar"
              :reduce="(x) => x.id"
              id="classifications"
              ep="v2/selects/ngo-classifications"
              ref="classifications"
            />
          </b-col>

          <b-col cols="12">
            <b-form-group class="">
              <div class="d-flex">
                <b-form-radio
                  name="state"
                  v-model="form.is_main"
                  class="mx-50 cursor-pointer custom-control-info"
                  value="1"
                >
                  <span class="cursor-pointer"> رئيسي </span>
                </b-form-radio>
                <b-form-radio
                  name="state"
                  v-model="form.is_main"
                  class="mx-50 cursor-pointer custom-control-info"
                  value="0"
                >
                  <span class="cursor-pointer"> فرعي </span>
                </b-form-radio>
              </div>
            </b-form-group>
          </b-col>
        </b-row>
        <hr />

        <b-row class="px-1 justify-content-end">
          <b-button @click="modalOpen = false" class="mx-1">إلغاء</b-button>
          <save-btn
            @click="$emit('confirm', form)"
            variant="primary"
            :loading="loading"
            :label="btnLabel"
          >
          </save-btn>
        </b-row>
      </b-form>
    </b-card-text>
  </b-modal>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BCardTitle,
  BModal,
  BFormGroup,
  BFormRadio,
  BForm,
  BFormTextarea,
  BButton,
} from "bootstrap-vue";
import formSelect from "@/components/form-select";
import formInput from "@/components/form-input";
import saveBtn from "@/components/loader-btn";
import formDatepicker from "@/components/form-datepicker";
const initForm = {
  is_main: "0",
  ngo_classification_id: null,
};

export default {
  components: {
    formInput,
    formSelect,
    BButton,
    formDatepicker,
    saveBtn,
    BRow,
    BCol,
    BCard,
    BCardText,
    BCardTitle,
    BModal,
    BFormGroup,
    BForm,
    BFormRadio,
    BFormTextarea,
  },
  props: {
    value: Boolean,
    title: String,
    btnLabel: String,
    loading: Boolean,
    intializeForm: {
      type: Object,
      default: () => initForm,
    },
  },
  data() {
    return {
      form: {},
    };
  },
  computed: {
    modalOpen: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
  },
  watch: {
    modalOpen(val) {
      if (val) this.init(this.intializeForm);
    },
  },

  methods: {
    init(form) {
      this.form = JSON.parse(JSON.stringify(form));
    },
  },
};
</script>
